import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare, faCheckSquare } from "@fortawesome/free-regular-svg-icons";

import { ProductsContext } from "../../../contexts/attributes";

const getUnfinalizedKeys = (list) => {
    return list.reduce((arr, u) => {
        if (!u.isFinalized) {
            arr.push(u.codingWipKey);
        }

        return arr;
    }, []);
};

const BulkToggle = (props) => {
    const { setBulkAll } = useContext(ProductsContext);
    const [bulkKeys, setBulkKeys] = useState(getUnfinalizedKeys(props.upcs));

    useEffect(() => {
        setBulkKeys(getUnfinalizedKeys(props.upcs));
    }, [props.upcs]);

    return (
        <div className="button-group -right">
            <button className="button" onClick={() => setBulkAll(false, bulkKeys)} title="Deselect All">
                <FontAwesomeIcon icon={faSquare} />
            </button>
            <button className="button" onClick={() => setBulkAll(true, bulkKeys)} title="Select All">
                <FontAwesomeIcon icon={faCheckSquare} />
            </button>
        </div>
    );
};

export default BulkToggle;
